import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { schemas, useForm } from "helpers/FormHelpers";
import { FormCheckbox, FormTextField } from "helpers/FormHelpersComponents";
import { useAppSelector } from "redux/hooks";
import { addFormSection, selectLensEditorForm } from "redux/slices/lensEditor";
import useAppDispatchWithSnackbar from "../../../helpers/hooks/useAppDispatchWithSnackbar";

interface NewFormSectionDialogProps {
  open: boolean;
  close: () => void;
  formPageId: number;
}

const NewFormSectionDialog = ({ open, close, formPageId }: NewFormSectionDialogProps) => {
  const lensForm = useAppSelector(selectLensEditorForm);
  const snackpatch = useAppDispatchWithSnackbar();

  const newSectionForm = useForm<"name" | "outcomeEnabled" | "validationEnabled">(
    {
      isValid: false,
      values: {
        name: "",
        outcomeEnabled: false,
        validationEnabled: false,
      },
      touched: {
        name: false,
        outcomeEnabled: false,
        validationEnabled: false,
      },
      errors: {
        name: [],
        outcomeEnabled: [],
        validationEnabled: [],
      },
    },
    {
      name: schemas.nonEmpty("Name"),
      outcomeEnabled: schemas.customType,
      validationEnabled: schemas.customType,
    }
  );
  const formState = newSectionForm.formStateHandle[0];

  const save = () => {
    snackpatch(
      addFormSection({
        formId: lensForm.id,
        name: formState.values.name,
        rank: lensForm.sections.length,
        outcomeEnabled: formState.values.outcomeEnabled,
        validationEnabled: formState.values.validationEnabled,
        formPageId,
      }),
      {
        successMessage: "Section added",
        errorMessage: "Unable to add section",
      }
    ).then(() => close());
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>New Form Section</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          "& .MuiTextField-root,.MuiFormControl-root,.MuiFormControlLabel-root": { m: 1 },
        }}>
        <FormTextField useForm={newSectionForm} id="name" label="Name" />
        <FormCheckbox useForm={newSectionForm} id="outcomeEnabled" label="Outcome Enabled" />
        <FormCheckbox useForm={newSectionForm} id="validationEnabled" label="Validation Enabled" />
      </DialogContent>
      <DialogActions>
        <Button sx={{ mr: 2 }} color="default" onClick={close}>
          Cancel
        </Button>
        <Button color="default" variant="contained" disabled={!formState.isValid} onClick={save}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewFormSectionDialog;
